import Axios from "../configs/axios.config";

// 📌 Projects API
export const getProjectList = (params) =>
    Axios.get(`/projects`, { params }).then((res) => res.data);
export const getBlogList = (params) =>
    Axios.get(`/blogs`, { params }).then((res) => res.data);
